import logo from './logo.svg';
import './App.css';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import SongMetadataEditor, { SongDataProvider, useUpdateSongData } from './SongMetadataEditor';
import PlayPage from './PlayPage';
//import songData from './data';

//const root = ReactDOM.createRoot(document.getElementById('root'));
//const songData = {};

/*
function App() {
  const setGlobalUpdateFunction = useUpdateSongData();

  useEffect(() => {
    // Expose the update function to the global scope
    window.updateSongData = setGlobalUpdateFunction;
    return () => {
      delete window.updateSongData; // Cleanup on unmount
    };
  }, [setGlobalUpdateFunction]);

  return (
    
   <PlayPage />
  );
}

ReactDOM.render(
  <SongDataProvider initialData={songData}>
    <App />
  </SongDataProvider>,
  //document.getElementById('root')
);

*/

function App() {


  
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
